import { BaseQueryFn } from "@reduxjs/toolkit/dist/query";
import axios, { AxiosRequestConfig } from "axios";

import { getCurrentSession } from "../auth";
export const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string },
  ): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
      uploadProgress?:AxiosRequestConfig["onUploadProgress"]
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params }) => {
    try {
      // Get fresh token for each request
      const currentSession = getCurrentSession();
      const token = currentSession?.accessToken;
      
      // Check if data is FormData to set appropriate headers
      const isFormData = data instanceof FormData;
      
      const result = await axios({
        headers: {
          "Accept-Language": localStorage.getItem('local'), // Add the Accept-Language header here.
          "Authorization": token ? `Bearer ${token}` : "",
          "Accept": "application/json",
          // Don't set Content-Type for FormData, let the browser set it with boundary
          ...(isFormData ? {} : { "Content-Type": "application/json" }),
        },
        url: baseUrl + url,
        method,
        data,
        params: { ...params},
      });
      return { data: result.data };
    } catch (axiosError) {
      return {
        error: axiosError,
      };
    }
  };
